import { useState, useEffect } from 'react';
import { api } from '../../../utils/api';

/**
 * The customer's original submission for a quote: `{ loading, submission, error }`.
 *
 * One read shared by the Customer note panel and the "Customer's submission"
 * dialog, so opening the dialog does not fetch the same thing twice. The read
 * is live, so a note the customer added after the drain still shows.
 *
 * `submission: null` means none on file, not an error. The `alive` flag drops
 * an answer that lands after the queue has moved to another deal.
 */
export default function useCustomerSubmission(dealId, quoteId, { enabled = true } = {}) {
    const [state, setState] = useState({ loading: enabled });

    useEffect(() => {
        if (!enabled || !dealId) {
            setState({ loading: false, submission: null });
            return undefined;
        }
        let alive = true;
        setState({ loading: true });
        const qs = quoteId ? `?quote_id=${quoteId}` : '';
        (async () => {
            try {
                const r = await api.get(`/api/deals/${dealId}/submission${qs}`);
                if (alive) setState({ loading: false, submission: r.submission ?? null });
            } catch (e) {
                if (alive) setState({ loading: false, error: e.message || 'Could not load the submission' });
            }
        })();
        return () => { alive = false; };
    }, [dealId, quoteId, enabled]);

    return state;
}
